import { render, staticRenderFns } from "./visitListCard2.vue?vue&type=template&id=27ebda6e&scoped=true"
import script from "./visitListCard2.vue?vue&type=script&lang=js"
export * from "./visitListCard2.vue?vue&type=script&lang=js"
import style0 from "./visitListCard2.vue?vue&type=style&index=0&id=27ebda6e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ebda6e",
  null
  
)

export default component.exports